import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue'
import VsTextInput from '@/components/vision/Inputs/VsTextInput.vue'
import VsWrapper from '@/components/vision/VsWrapper.vue'
import FormLayout from '@/components/common/FormLayout.vue'
import VsSnackbar from '@/components/vision/VsSnackbar.vue'
import VsForm from '@/components/vision/VsForm.vue'
import { rejectJobApprovalMutation } from '@/api/jobs'

interface Props {
  jobId: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ApprovalRejectionForm',
  props: {
    jobId: null
  },
  emits: ["approval-rejected-success", "dismiss"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'approval-rejected-success')
  (e: 'dismiss')
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  jobId: string
}





const isRejecting = ref(false)
const rejectionMessage = ref('')
const isSnackbarVisible = ref(false)

const { mutateAsync: rejectApproval } = rejectJobApprovalMutation()

async function onSubmit() {
  isRejecting.value = true

  try {
    await rejectApproval({
      id: props.jobId,
      rejectionMessage: rejectionMessage.value,
    })
    emit('approval-rejected-success')
  } catch {
    isSnackbarVisible.value = true
  } finally {
    isRejecting.value = false
  }
}

function dismiss() {
  emit('dismiss')
}

return { __sfc: true,props, emit, isRejecting, rejectionMessage, isSnackbarVisible, rejectApproval, onSubmit, dismiss, VsTextInput, VsWrapper, FormLayout, VsSnackbar, VsForm }
}

})